// The Wind Widgets page's spot, from its URL (replaces the spot resolution in WindAlert-Web
// WindWidgets.aspx.vb). Routed URLs (see WindAlert-Web Global.asax):
//   /widget/{id}             station spot
//   /widget/fav/{id}         favorite spot
//   /{activity}/widget/{id}  station spot
// Legacy query strings are also supported: ?spotid=, ?favspotid=, ?latlon={lat},{lon}.
// Unlike the legacy page there's no default spot (it fell back to 411); no spot in the URL
// means the page shows that the spot couldn't be found.
export default function widgetSpotFromUrl(location = window.location) {
  const searchParams = new URLSearchParams(location.search)

  let id
  let lat
  let lon
  let isSpot = true
  let isFavoriteSpot = false
  let isArbitrarySpot = false

  const routed = location.pathname.match(/\/widget\/(?:(fav)\/)?(\d+)\/?$/i)

  if (routed) {
    const [, favorite, spotId] = routed

    id = spotId

    if (favorite) {
      isFavoriteSpot = true
      isSpot = false
    }
  } else if (searchParams.has('spotid')) {
    id = searchParams.get('spotid')
  } else if (searchParams.has('favspotid')) {
    id = searchParams.get('favspotid')
    isFavoriteSpot = true
    isSpot = false
  } else if (searchParams.has('latlon')) {
    [lat, lon] = searchParams.get('latlon').split(',')
    isArbitrarySpot = true
    isSpot = false
  }

  return { id, lat, lon, isSpot, isFavoriteSpot, isArbitrarySpot }
}
